const indexItems = [
  { label: '热血漫画', icon: 'ri-fire-line', desc: '燃爆全场的战斗与成长故事', color: 'primary' },
  { label: '修仙漫画', icon: 'ri-star-line', desc: '修真问道，逆天改命的仙侠世界', color: 'accent' },
  { label: '恋爱漫画', icon: 'ri-heart-line', desc: '甜蜜浪漫的心动物语', color: 'secondary' },
  { label: '玄幻漫画', icon: 'ri-magic-line', desc: '异世大陆的奇幻冒险旅程', color: 'primary' },
  { label: '悬疑漫画', icon: 'ri-search-eye-line', desc: '扣人心弦的推理与反转', color: 'accent' },
  { label: '搞笑漫画', icon: 'ri-emotion-laugh-line', desc: '轻松幽默的爆笑日常', color: 'secondary' },
  { label: '古风漫画', icon: 'ri-brush-line', desc: '唯美典雅的古风世界', color: 'primary' },
  { label: '科幻漫画', icon: 'ri-rocket-line', desc: '未来世界的科技幻想', color: 'accent' },
  { label: '电竞漫画', icon: 'ri-gamepad-line', desc: '指尖竞技的热血青春', color: 'secondary' },
];

const colorMap: Record<string, { bg: string; iconColor: string }> = {
  primary: { bg: 'bg-primary-100 group-hover:bg-primary-200', iconColor: 'text-primary-600' },
  accent: { bg: 'bg-accent-100 group-hover:bg-accent-200', iconColor: 'text-accent-600' },
  secondary: { bg: 'bg-secondary-100 group-hover:bg-secondary-200', iconColor: 'text-secondary-600' },
};

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            漫画大全
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按类型快速浏览漫画全集完整版资源
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {indexItems.map((item, idx) => {
            const colors = colorMap[item.color];
            return (
              <div
                key={idx}
                className={`${colors.bg} rounded-xl p-5 cursor-pointer transition-colors duration-200 group`}
              >
                <div className="flex items-center gap-3 mb-2">
                  <div className={`w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center`}>
                    <i className={`${item.icon} ${colors.iconColor} text-base`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900">{item.label}</h3>
                </div>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}